export default __webpack_public_path__ + "static/media/news5.b78b9914.jpg";